package component.input

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import theme.ThemeColor

@Composable
fun TextInputField(placeholder: String, value: String = "", onChange: (String) -> Unit) {
    var text by remember { mutableStateOf(value) }
    OutlinedTextField(
        value = text,
        onValueChange = {
            text = it
            onChange(it)
        },
        label = { Text(placeholder) },
        colors = OutlinedTextFieldDefaults.colors(
            cursorColor = ThemeColor.shared().PrimaryColor,
            focusedBorderColor = ThemeColor.shared().PrimaryColor,
            focusedLabelColor = ThemeColor.shared().PrimaryColor,
            unfocusedBorderColor = ThemeColor.shared().InputFieldBorder,
        ),
        modifier = Modifier.fillMaxWidth().padding(start = 8.dp, end = 8.dp)
    )
}